interface ShopifyProduct {
  handle?: string;
  variants?: Array<{ sku?: string }>;
}

interface SEOMetadata {
  canonicalUrl?: string;
}

const languageMapping = {
  'en-us': '',
  'en-au': 'au',
  'en-ca': 'ca',
  'en-gb': 'gb',
  'en-gb-nl': 'nl',
  'fr-be': 'be',
  'fr-fr': 'fr',
  'de-de': 'de',
  'de-ch': 'ch',
  'en-ie': 'ie',
  'es-es': 'es',
  'it-it': 'it',
};

export function getCanonicalUrl(
  siteUrl: string,
  locale: string,
  shopifyProduct: ShopifyProduct,
  seoMetadata: SEOMetadata,
  isNonCommerce = false
): string {
  if (!siteUrl || !shopifyProduct) {
    return '';
  }
  if (seoMetadata?.canonicalUrl) {
    return seoMetadata.canonicalUrl;
  }
  const handle = shopifyProduct?.handle;
  const skuRaw = shopifyProduct?.variants?.[0]?.sku;
  if (!handle || !skuRaw) {
    return '';
  }
  const sku = skuRaw.replace(/\//g, '_');
  const lang = languageMapping[locale.toLowerCase()] ?? '';
  const langPrefix = lang ? `/${lang}` : '';
  if (isNonCommerce) {
    return `${siteUrl}${langPrefix}/i/${handle}/${sku}`;
  }
  return `${siteUrl}${langPrefix}/p/${handle}/${sku}`;
}
